import HeaderSite from '@/components/common/header/Site'

const Header = ({ data, navIcons = [] }) => {
  const iconsByTitle = new Map(
    navIcons
      .filter((icon: any) => icon.headerNavigationIcons?.iconImage?.node?.sourceUrl)
      .map((icon: any) => [icon.title.toLowerCase().trim(), icon.headerNavigationIcons.iconImage])
  )

  const menuItems = data?.navigationMenus?.find((m) => m.name === 'Header')?.items || []

  const desktop = menuItems.map((item: any) => ({
    ...item,
    iconImage: iconsByTitle.get(item.title?.toLowerCase().trim()) || null
  }))

  const menu = { desktop, mobile: [] }

  return <HeaderSite menu={menu} />
}

export default Header
